import React, { FC } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Icon from '../../components/icon/Icon';
// import Logo from '../../components/Logo';
// import ddSmallLogo from '../../assets/img/dd-logo-mini.png';
import ddMiniLogo from '../../assets/img/dd-logo-nav.png';
import ddSmallLogo from '../../assets/img/dd_horizontal-logo-nav.png';

interface IBrandProps {
	asideStatus: boolean;
	setAsideStatus(...args: unknown[]): unknown;
}
const Brand: FC<IBrandProps> = ({ asideStatus, setAsideStatus }) => {
	return (
		<div className='brand' onClick={() => setAsideStatus(!asideStatus)}>
			<div className='brand-logo'>
				<h1 className='brand-title '>
					<Link to='/dashboard' aria-label='Logo'>
						<img src={ddSmallLogo} className='img-fluid'  alt='Diligent Dollar Logo' style={{ width: '100%'}}/>
					</Link>
				</h1>
			</div>
			<button
				type='button'
				className='btn brand-aside-toggle'
				aria-label='Toggle Aside'
				>
				<Icon icon='FirstPage' className='brand-aside-toggle-close' />
				
				<Link to='/' aria-label='Logo' className='nav-logo brand-aside-toggle-open'>
					<img src={ddMiniLogo} className='img-fluid'  alt='Diligent Dollar Logo' style={{ height: '30px'}}/>
				</Link>
				<Icon icon='LastPage' className='brand-aside-toggle-open' />
			</button>
		</div>
	);
};
Brand.propTypes = {
	asideStatus: PropTypes.bool.isRequired,
	setAsideStatus: PropTypes.func.isRequired,
};

export default Brand;
